import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';

Vue.use(Vant);

Vue.config.productionTip = false;

document.title = 'AIGC数字产业园证书查询系统';

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');

// 取消控制台输出
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}